// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".total-invest-dialog .el-dialog__body {\n  height: 500px;\n  overflow: auto;\n}\n.total-invest-dialog .el-input .el-input__inner {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
